export function nativeTongueFor(userNativeLanguage: string | undefined, defaultNativeLanguage: string): string {
  return userNativeLanguage ?? defaultNativeLanguage
}
